import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/**
 * Démarrage.
 *
 * Plus aucun fournisseur d'identité à monter ici : l'authentification passe par
 * la micro-API PHP (`@/services/auth.service`), dont l'état vit dans un magasin
 * observable — `useAuth` s'y abonne, sans contexte React à envelopper.
 */
/**
 * Purge unique des données de démonstration.
 *
 * L'ancienne console `/admin` semait des conducteurs fictifs dans
 * localStorage au premier chargement (`myautolink_fleet_drivers`), et un
 * profil de véhicule d'exemple (`myautolink_profile`). Ces clés survivent à
 * un déploiement : elles restent dans le navigateur de tous ceux qui ont
 * ouvert la version précédente, et continuent d'afficher de fausses données.
 *
 * Seules ces deux clés sont effacées. Les autres `myautolink_*` sont de
 * vraies données de l'utilisateur — trajets hors ligne en attente de
 * synchronisation, favoris, thème, objectif mensuel — et ne sont pas
 * touchées.
 */
try {
  const stamp = 'autolink.demo_purged.v1'
  if (!localStorage.getItem(stamp)) {
    localStorage.removeItem('myautolink_fleet_drivers')
    localStorage.removeItem('myautolink_profile')
    localStorage.setItem(stamp, '1')
  }
} catch {
  /* mode privé : rien à purger */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * Service worker.
 *
 * Uniquement en build de production : en développement, un worker qui sert des
 * fichiers depuis son cache masque les modifications et fait perdre un temps
 * considérable. Un worker installé lors d'un essai précédent est d'ailleurs
 * désenregistré au passage.
 *
 * L'enregistrement attend `load` pour ne pas disputer la bande passante au
 * premier rendu.
 */
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('Service worker non enregistré :', err)
      })
    })
  } else {
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()))
  }
}
